export default __webpack_public_path__ + "static/media/navbar-barred-list-orange.8df32c60.svg";